const desktop = theme => {
  const {toVW} = theme;
  return {
    customPopup: {
      '& .ant-modal-content': {
        '& .ant-modal-close': {
          right: 10,
          top: 14,
        },
      },
    },
  };
};

const mobile = theme => {
  const {toVW} = theme;

  return {
    customPopup: {
      borderRadius: 10,
      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10) inset',
      padding: 0,
      '& .ant-modal-header': {
        padding: 0,
        textAlign: 'center',
        background: 'transparent',
        border: 'none',
        '& .ant-modal-title': {
          color: 'white',
          fontSize: 20,
          fontWeight: 700,
        },
      },
      '& .ant-modal-content': {
        padding: 15,
        background:
          'linear-gradient(90deg, rgba(255, 255, 255, 0.05)0%, rgba(153, 153, 153, 0.05)100%), #202633',
        borderRadius: '10px',
        '& .ant-modal-close': {
          top: 5,
          right: 5,
          width: 'auto',
          height: 'auto',
          '& .ant-modal-close-x': {
            // fontSize: '35px',
          },
        },
        '& .ant-modal-body': {
          padding: 0,
          color: 'white',
          borderRadius: '10px',
          fontSize: 14,
          fontWeight: 400,
        },
      },

      '& .ant-modal-footer': {
        border: 'none',
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
      },
    },

    backIcon: {
      position: 'absolute',
      left: -5,
      top: 12,
      transform: 'rotate(180deg)',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
